import { 
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, db } from './config';

// Kayıt Ol
export const registerUser = async (email, password, displayName) => {
  try {
    // 1. Firebase Auth ile kullanıcı oluştur
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // 2. Profil ismini güncelle
    await updateProfile(user, {
      displayName: displayName
    });

    // 3. Firestore'da kullanıcı profili oluştur
    await setDoc(doc(db, 'users', user.uid, 'profile', 'info'), {
      email: email,
      displayName: displayName,
      createdAt: new Date().toISOString(),
      photoURL: user.photoURL || null
    });

    // 4. Varsayılan ayarları oluştur
    await setDoc(doc(db, 'users', user.uid, 'settings', 'preferences'), {
      theme: 'light',
      defaultPlatforms: [],
      autoResize: true
    });

    return { success: true, user };
  } catch (error) {
    console.error('Kayıt hatası:', error);
    return { 
      success: false, 
      error: getErrorMessage(error.code) 
    };
  }
};

// Giriş Yap
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error('Giriş hatası:', error);
    return { 
      success: false, 
      error: getErrorMessage(error.code) 
    };
  }
};

// Google ile Giriş
export const loginWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // Firestore'da profil var mı kontrol et
    const profileRef = doc(db, 'users', user.uid, 'profile', 'info');
    const profileSnap = await getDoc(profileRef);

    if (!profileSnap.exists()) {
      // İlk kez giriş yapıyorsa profil oluştur
      await setDoc(profileRef, {
        email: user.email,
        displayName: user.displayName,
        createdAt: new Date().toISOString(),
        photoURL: user.photoURL
      });

      await setDoc(doc(db, 'users', user.uid, 'settings', 'preferences'), {
        theme: 'light',
        defaultPlatforms: [],
        autoResize: true
      });
    }

    return { success: true, user };
  } catch (error) {
    console.error('Google giriş hatası:', error);
    return { 
      success: false, 
      error: getErrorMessage(error.code) 
    };
  }
};

// Çıkış Yap
export const logoutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    console.error('Çıkış hatası:', error);
    return { success: false, error: error.message };
  }
};

// Şifre Sıfırlama
export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    console.error('Şifre sıfırlama hatası:', error);
    return { 
      success: false, 
      error: getErrorMessage(error.code) 
    };
  }
};

// Auth State Listener
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Hata mesajlarını Türkçeleştir
const getErrorMessage = (errorCode) => {
  const errorMessages = {
    'auth/email-already-in-use': 'Bu e-posta adresi zaten kullanımda',
    'auth/invalid-email': 'Geçersiz e-posta adresi',
    'auth/operation-not-allowed': 'Bu işlem şu anda devre dışı',
    'auth/weak-password': 'Şifre çok zayıf (en az 6 karakter)',
    'auth/user-disabled': 'Bu hesap devre dışı bırakılmış',
    'auth/user-not-found': 'Kullanıcı bulunamadı',
    'auth/wrong-password': 'Hatalı şifre',
    'auth/too-many-requests': 'Çok fazla deneme. Lütfen daha sonra tekrar deneyin',
    'auth/network-request-failed': 'Ağ bağlantısı hatası'
  };

  return errorMessages[errorCode] || 'Bir hata oluştu. Lütfen tekrar deneyin.';
};